import React from "react";

const Spinner = () => {
    return (
        <div className="spinner-section">
            <div className="spinner-border spinner-color m-2" role="status">
                <span className="visually-hidden">Loading...</span>
            </div>
            <p><em>Loading...</em></p>
        </div>
    );
};

export default Spinner;
